import { memo } from 'react'

import RecaptchaScope from './RecaptchaScope'

const WithRecaptchaProvider = ({ children }: { children: React.ReactElement }) => {
  return <RecaptchaScope>{children}</RecaptchaScope>
}

export default memo(WithRecaptchaProvider, (old, latest) => {
  return old.children.type.name === latest.children.type.name
})
